<div class="integrations__table">
    <div class="vox-table integrations__table__table">
      <table>
        <thead>
          <tr>
            <td>#</td>
            <td *ngIf="context === 'global'" translate>common.integrations.table.company-id</td>
            <td translate>common.integrations.table.name</td>
            <td translate>common.integrations.table.status.label</td>
            <td translate>common.integrations.table.platform</td>
            <td translate>common.integrations.table.auth-method</td>
            <td *ngIf="context === 'company'" translate>common.integrations.table.enable</td>
            <td translate>common.integrations.table.actions</td>
          </tr>
        </thead>
        <tbody *ngIf="!loading">
          <ng-container *ngFor="let integration of integrations; let i = index">
            <tr *ngIf="integration._isLoading" class="user-data-row">
              <td colspan="8">
                <ngx-skeleton-loader [theme]="{'margin-bottom': 0 }"></ngx-skeleton-loader>
              </td>
            </tr>
            <tr *ngIf="!integration._isLoading">
              <td>{{ integration.id }}</td>
              <td *ngIf="context === 'global'">
                <a routerLink="/dashboard/companies/{{integration.company_id}}/integrations">{{integration.company_id}}</a>
              </td>
              <td>{{ integration.name }}</td>
              <td>
                <gdp-integration-status [platformName]="integration.name" [status]="integration.status"></gdp-integration-status>
              </td>
              <td>{{ integration.name }}</td>
              <td>{{ authMethodsType[integration.authorization_method.authorization_type] }}</td>
              <td *ngIf="context === 'company'">
                <div class="enable__integration">
                  <vox-toggle [(toggleOn)]="integration.enabled" [config]="{isAquamarine: true}" (change)="enableDisableIntegration(integration)"></vox-toggle>
                </div>
              </td>
              <td>
                <div class="integration-data-row__actions--wrapper">
                  <button *ngIf="context === 'company'" (click)="onForceContactSync(integration)" class="vox-btn btn btn-warning" [ngbTooltip]="'common.integrations.info.sync' | translate"><i
                      class="icon-small-update"></i></button>
                  <button *ngIf="context === 'company'" class="vox-btn btn btn-warning" [disabled]="!integration.enabled" (click)="openEditIntegrationPopup(integration)" [ngbTooltip]="'common.integrations.info.edit' | translate"><i
                      class="icon-small-edit"></i></button>
                  <button class="vox-btn btn btn-warning" (click)="openIntegrationDetails(integration)"
                    [ngbTooltip]="'common.integrations.info.details' | translate"><i
                      class="icon-small-info"></i></button>
                  <button *ngIf="context === 'company'" class="vox-btn btn btn-danger" (click)="onDeleteIntegration(integration)"
                    [ngbTooltip]="'common.integrations.info.delete' | translate"><i
                      class="icon-small-delete"></i></button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
        <tbody *ngIf="loading">
          <tr *ngFor="let i of [1,2,3,4,5,6]">
            <td colspan="8">
              <ngx-skeleton-loader [theme]="{'margin':'0'}"></ngx-skeleton-loader>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading && integrations?.length === 0">
          <tr>
            <td colspan="8" translate>common.integrations.table.empty</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
